var app = angular.module('rmUser');

app.controller('UserOverviewCtrl', require('./user_overview_ctrl'));
app.controller('UserFormCtrl', require('./user_form_ctrl'));
app.controller('UserProfileCtrl', require('./user_profile_ctrl'));
app.controller('UserInviteCtrl', require('./user_invite_ctrl'));
app.controller('InviteUserDialogCtrl', require('./invite_user_dialog_ctrl'));